module.exports = "<ion-app [ngClass]=\"{'dark-theme': theme.darkTheme}\">\n  <ion-router-outlet>\n  </ion-router-outlet>\n</ion-app>"